module.exports = __webpack_public_path__ + "static/hero-4243b69008ece76609bacb688e01b9a2.svg";